import { render } from "./SystemHealthMonitor.vue?vue&type=template&id=3a3fc615"
import script from "./SystemHealthMonitor.vue?vue&type=script&lang=js"
export * from "./SystemHealthMonitor.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"SystemHealthMonitor.vue"]])

export default __exports__